module.exports = __webpack_public_path__ + "img/wj_logo.10ea6ba7.png";